import Box from 'UIKit/Box/Box'
import Flex from 'UIKit/Box/Flex'
import Image from 'UIKit/Image'
import Link from 'UIKit/Link'
import Skeleton from 'UIKit/Skeleton'
import { RouteConfig } from 'config/constants/route'
import { PinnedPromotion } from 'config/types/promotion'
import { Trans } from 'react-i18next'
import { useGetPromotionMenu } from 'state/app/hooks'
import styled from 'styled-components'
import { Icons } from 'svgs'
import { usePromotionSlugDetails } from 'views/Promotions/hooks'

const StyledContainer = styled(Box)`
  background: rgba(224, 224, 224, 0.04);
  border-radius: ${({ theme }) => theme.radii.tiny};
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  ${({ theme: { mediaQueries } }) => mediaQueries.sm} {
    max-width: 212px;
  }
`

const StyledLink = styled(Link)`
  display: flex;
  width: 100% !important;
  align-items: center;
  justify-content: center;

  svg {
    width: 20px;
    height: 20px;
    transform: rotate(-90deg);
    fill: ${({ theme }) => theme.colors.textSubtle};
    margin-left: 8px;
  }

  &:hover {
    svg {
      fill: ${({ theme }) => theme.colors.text};
    }
  }
`
const StyledWrapImage = styled(Flex)`
  overflow: hidden;
  border-radius: ${({ theme }) => theme.radii.tiny};
`

const StyledImage = styled(Image)`
  transition: ${({ theme }) => theme.transitions.fast};
  &:hover {
    transform: scale(1.05);
  }
`

export const PromotionExpandContent = () => {
  const promotions = useGetPromotionMenu()

  return (
    <StyledContainer padding="8px">
      {promotions.length ? (
        <>
          {promotions.map((promo) => (
            <PromotionItem key={promo.slug} promo={promo} />
          ))}
        </>
      ) : (
        <>
          <Flex mb="12px">
            <Skeleton width="100%" height="48px" />
          </Flex>

          <Flex mb="12px">
            <Skeleton width="100%" height="48px" />
          </Flex>
        </>
      )}

      <StyledLink id="allpromotions-text" href={RouteConfig.Promotions} color="textSubtle" fontSize="12px">
        <Trans>All Promotions</Trans>
        <Icons.ArrowDownIcon />
      </StyledLink>
    </StyledContainer>
  )
}

const PromotionItem: React.FC<{ promo: PinnedPromotion }> = ({ promo }) => {
  const routeDetails = usePromotionSlugDetails(promo)

  return (
    <Link
      title={'HunnyPlay promotion'}
      id="promotion-item"
      key={promo.slug}
      href={routeDetails.url}
      external={routeDetails.isExternal}
      maxWidth="368px"
    >
      <StyledWrapImage mb="8px" overflow="hidden" width={['256px', '', '200px']} height={['60px', '', '48px']}>
        <StyledImage
          objectFit="cover"
          width={250}
          height={59}
          src={promo.menuImageUrl}
          alt="HunnyPlay promotion"
          blurLoader
        />
      </StyledWrapImage>
    </Link>
  )
}
export default PromotionExpandContent
